import gql from 'graphql-tag';

export default gql`
    fragment GravesideMusicSongs on Funeral {
        GravesideMusicSongs {
            ID
            Name
            Artist
            Pathname
            SongSort
        }
    }
`;
